import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as Gear } from '../../../assets/icons/Gear.svg';
import { ReactComponent as SignOut } from '../../../assets/icons/SignOut.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';
import { ReactComponent as ArrowWhite } from '../../../assets/icons/ArrowWhite.svg';
import { ReactComponent as MeloLogoWhite } from '../../../assets/icons/MeloLogoWhite.svg';
import { ReactComponent as MeloLogoOWhite } from '../../../assets/icons/MeloLogoOWhite.svg';
import { ReactComponent as TriangleAdmiration } from '../../../assets/icons/TriangleAdmiration.svg';

import { useSidebar } from '../../../services/hooks';
import { ProfileImage } from '../../../components';
import { paths } from '../../../routes';
import { logOutUserAction } from '../../../store/slices/user';
import Business from '../Business/Business';

import classes from './Aside.module.scss';
import { useQueryClient } from 'react-query';
import { useState } from 'react';

const Module = ({
  path,
  onClick,
  Icon,
  label,
  pathname,
  LeftComponent,
  open,
  subModules,
  openSubModules,
  openSubModule,
  setModuleSelected
}) => {
  const content = (
    <div
      className={classes['div-son-module']}
      onClick={() => {
        if (subModules && !open) {
          openSubModules(label);
        } else if (setModuleSelected) {
          setModuleSelected(label);
        }
      }}>
      <div className={`${classes['first-div']} ${open ? classes['margin-box'] : ''}`}>
        {LeftComponent ? LeftComponent : <Icon title={label} className={classes.icon} />}
        {open && <span className='medium-16'>{label}</span>}
      </div>
      {subModules && open && <ArrowWhite className={openSubModule ? classes.arrow : classes['arrow-selected']} />}
    </div>
  );
  const moduleClass = `${classes.module} ${path && pathname === path ? classes.selected : ''}`;

  return onClick ? (
    <button name={label} className={moduleClass} onClick={onClick}>
      {content}
    </button>
  ) : (
    <>
      {subModules ? (
        <div className={classes.module}>
          {content}

          {subModules &&
            openSubModule === label &&
            open &&
            subModules.map(({ label, pathSubModule }, index) => {
              const moduleSubClass = `${classes['sub-module']} ${classes.module} ${pathSubModule && pathname === pathSubModule ? classes.selected : ''
                }`;
              return (
                // Corregido: Eliminado fragmento React innecesario y agregada key única
                // para evitar warnings de React sobre elementos sin key en mapeos
                <Link key={`${label}-${index}`} className={moduleSubClass} to={pathSubModule}>
                  <span className={`${classes['label-link-sub-module']} medium-16`}>{label}</span>
                </Link>
              );
            })}
        </div>
      ) : (
        <Link className={moduleClass} to={path}>
          {content}
        </Link>
      )}
    </>
  );
};

const AsideWeb = ({ isOpen, onAsideToggle, openToggleHandler }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const [openSubModule, setOpenSubModule] = useState();

  const queryClient = useQueryClient();
  const { modules } = useSidebar();

  const {
    profile: { name, lastName }
  } = useSelector(state => state.userData);

  const closeSesionHandler = () => {
    queryClient.clear();
    dispatch(logOutUserAction());
  };

  const handleHelpLink = () => {
    window.open('https://meloapp-public-assets.s3.us-east-2.amazonaws.com/Materialayuda.pdf', '_blank');
  };

  const userFormatedName = `${name[0].toUpperCase()}${name.slice(1)} ${lastName[0].toUpperCase()}.`;

  const openClass = isOpen ? classes.open : classes.closed;

  const setModuleSelected = module => {
    setOpenSubModule(module);
  };

  const onAsideToggleHandler = () => {
    onAsideToggle();
    isOpen && setOpenSubModule();
  };

  const openSubModules = module => {
    openToggleHandler();
    setOpenSubModule(module);
  };

  return (
    <aside className={`${classes.container} ${openClass}`}>
      <div className={classes['open-toggler']} onClick={onAsideToggleHandler}>
        <ArrowDown className={isOpen ? classes.left : classes.right} />
      </div>
      {isOpen ? (
        <MeloLogoWhite className={`${classes.melo} ${classes['melo-complete']} ${openClass}`} />
      ) : (
        <MeloLogoOWhite className={classes.melo} />
      )}
      <div className={classes['main-modules']}>
        {modules.map(({ path, label, Icon, subModules }) => (
          <Module
            openSubModules={openSubModules}
            key={path}
            path={path}
            Icon={Icon}
            label={label}
            pathname={pathname}
            open={isOpen}
            subModules={subModules}
            openSubModule={openSubModule}
            setModuleSelected={setModuleSelected}
          />
        ))}
      </div>
      <div className={classes.config}>
        <Module onClick={handleHelpLink} Icon={TriangleAdmiration} label='Guía' pathname={pathname} open={isOpen} setModuleSelected={setModuleSelected} />
        <Module path={paths.config} Icon={Gear} label='Configuración' pathname={pathname} open={isOpen} setModuleSelected={setModuleSelected} />
        {isOpen && <Business className={classes.business} />}
      </div>
      <div className={classes.profile}>
        <Module
          path={paths.profiles}
          pathname={pathname}
          LeftComponent={<ProfileImage name={name} lastName={lastName} />}
          label={userFormatedName}
          open={isOpen}
          setModuleSelected={setModuleSelected}
        />
        <Module onClick={closeSesionHandler} Icon={SignOut} label='Cerrar sesión' open={isOpen} />
      </div>
      <div className={classes.backdrop} onClick={onAsideToggle}></div>
    </aside>
  );
};

export default AsideWeb;
